import type { StockKlineBar } from "fin-web-components";
import { useLongfansMock } from "../../global/GlobalMock";
import { post } from "../../utils/backend";
import { mockStockDayKlinesByCode } from "./StockKlineMock";

export interface QueryStockDayKlinesParam {
  stockCode: string;
  /** 默认 120，最大 800；倒序，index0 最新 */
  size?: number;
}

const QUERY_STOCK_DAY_KLINES_URL = "/lark/app/stock/queryStockDayKlines";

const StockKlineApi = {
  async queryStockDayKlines(
    stockCode: string,
    size = 120
  ): Promise<StockKlineBar[]> {
    const code = stockCode.trim();
    if (!code) {
      return [];
    }
    if (useLongfansMock) {
      return mockStockDayKlinesByCode(code, size);
    }
    const r = await post<QueryStockDayKlinesParam, StockKlineBar[]>(
      QUERY_STOCK_DAY_KLINES_URL,
      { stockCode: code, size }
    );
    if (typeof r === "string" || !Array.isArray(r)) {
      return [];
    }
    return r;
  },
};

export default StockKlineApi;
